//LIVE SERVER
const API_BASE_URL = "https://api.goodpeople.live/api";
const PRE_PROD_URL = "https://preprodapi.goodpeople.live/api";

export const LoginApi = async ({ phoneNumber, password }) => {
  // console.log(phoneNumber, password);
  try {
    const response = await fetch(`${API_BASE_URL}/users/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phoneNumber,
        password,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("Failed to Login:", error);
  }
};

export const RegisterApi = async ({
  name,
  phoneNumber,
  email,
  password,
  dateOfBirth,
  gender,
}) => {
  const credit = 3600;
  const isActive = true;
  const isGPN = false;
  const helped = 0;
  const talkHours = 0;
  console.log(
    "RegisterApi params",
    "name:",
    name,
    "phoneNumber",
    phoneNumber,
    "email",
    email,
    "password",
    password,
    "dateOfBirth",
    dateOfBirth,
    "gender",
    gender,
    "credit",
    credit,
    "isActive",
    isActive,
    "isGPN",
    isGPN,
    "talkHours",
    talkHours
  );
  try {
    const response = await fetch(`${API_BASE_URL}/users/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        phoneNumber,
        email,
        password,
        dateOfBirth,
        credit,
        gender,
        isActive,
        isGPN,
        helped,
        talkHours,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("RegisterApi Error", error);
    throw error;
  }
};

export const AgoraStartApi = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  // console.log('UserId:',userId,'Token:',token);
  try {
    const response = await fetch(
      `${API_BASE_URL}/agora/start-call?userId=${userId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // console.log(response);

    if (response.ok) {
      const data = await response.json();
      // console.log("AgoraStartApi response",data);
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("AgoraStartApi Failed", e);
  }
};

export const AgoraStartVideoApi = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  const callType = true;
  // console.log('UserId:',userId,'Token:',token);
  try {
    const response = await fetch(`${API_BASE_URL}/agora/start-videocall`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        userId,
        callType,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("AgoraStartVideoApi Failed", e);
  }
};

export const AgoraEndApi = async ({ time, isVideo }) => {
  console.log("AgoraEndApi time:", time, "isVideo", isVideo);
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(`${API_BASE_URL}/agora/end-call`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        userId,
        time,
        isVideo,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("AgoraEndApi Failed", e);
  }
};



export const GetFriendDetailsApi = async (channelId) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) return null;
  const token = userData.token;
  console.log("UserId:", userData.userId);
  try {
    const response = await fetch(
      `${API_BASE_URL}/agora/start-call?channelId=${channelId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("GetFriendDetailsApi Failed", e);
  }
};

export const GetFriendRequestListApi = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(
      `${API_BASE_URL}/friend-requests/friendrequest/${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("GetFriendRequestListApi Failed", e);
  }
};

export const GetFriendListApi = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) return null;
  const userId = userData.userId;
  const token = userData.token;

  console.log("GetFriendListApi is working", userId);
  try {
    const response = await fetch(
      `${API_BASE_URL}/friend-requests/friendlist/${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("GetFriendListApi Failed", e);
  }
};

export const SendFriendRequestApi = async ({ senderId, receiverId }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) return null;
  const token = userData.token;
  console.log("SendFriendRequestApi is working", senderId, receiverId);
  try {
    const response = await fetch(`${API_BASE_URL}/friend-requests`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        senderId,
        receiverId,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("SendFriendRequestApi Failed", e);
  }
};

export const AcceptFriendRequestApi = async (tableId) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) return null;
  const token = userData.token;
  // console.log("AcceptFriendRequestApi is working with Table Id", tableId);
  try {
    const response = await fetch(
      `${API_BASE_URL}/friend-requests/${tableId}/accept`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("AcceptFriendRequestApi Failed", e);
  }
};

export const DeleteFriendRequestApi = async (tableId) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) return null;
  const token = userData.token;
  console.log("DeleteFriendRequestApi is working", tableId);
  try {
    const response = await fetch(`${API_BASE_URL}/friend-requests/${tableId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("DeleteFriendRequestApi Failed", e);
  }
};

export const CallFriendApi = async ({ senderId, receiverId }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) return null;
  const token = userData.token;
  console.log("CallFriendApi is working", senderId, receiverId);
  try {
    const response = await fetch(`${API_BASE_URL}/agora/start-callWithFriend`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        senderId,
        receiverId,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("CallFriendApi Failed", e);
  }
};



export const RazorPayOrderIdApi = async ({ amount, orderType }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  console.log(
    "RazorPayOrderIdApi is working with amount:",
    amount,
    "userId:",
    userId
  );

  // const orderType = 'AudioTalkTime';
  try {
    const response = await fetch(`${API_BASE_URL}/order/create-order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        amount,
        userId,
        orderType,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("RazorPayOrderIdApi Failed", e);
  }
};

export const RazorPayPaymentStatusApi = async ({
  paymentId,
  signature,
  orderId,
}) => {
  console.log(
    "RazorPayPaymentStatusApi is working with paymentId:",
    paymentId,
    "signature",
    signature,
    "orderId",
    orderId
  );
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const token = userData.token;
  try {
    const response = await fetch(`${API_BASE_URL}/order/verify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        paymentId,
        orderId,
        signature,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("RazorPayPaymentStatusApi Failed", e);
  }
};

export const LocationSendApi = async ({
  address,
  latitude,
  longitude,
  isDefault,
}) => {
  console.log(
    "LocationSendApi params",
    address,
    latitude,
    longitude,
    isDefault
  );
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(`${API_BASE_URL}/addresses`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        userId,
        address,
        latitude,
        longitude,
        isDefault,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("LocationSendApi Failed", e);
  }
};

export const LocationListApi = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(`${API_BASE_URL}/addresses/user/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("LocationSendApi Failed", e);
  }
};

export const ImageSendApi = async ({ file }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(
      `${API_BASE_URL}/users/${userId}/uploadImage`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          file,
        }),
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("LocationSendApi Failed", e);
  }
};

export const UpdateApi = async (data) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("UpdateApi error", e);
  }
};

export const DefaultAddressApi = async ({ id }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  const isDefault = true;
  try {
    const response = await fetch(`${API_BASE_URL}/addresses/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        isDefault,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("DefaultAddressApi error", e);
  }
};

export const DeleteAddressApi = async ({ id }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(`${API_BASE_URL}/addresses/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("DefaultAddressApi error", e);
  }
};

export const GetReferralCode = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(`${API_BASE_URL}/referrals/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("GetReferralCode error", e);
  }
};

export const ForgotPassApi = async ({ number, password }) => {
  console.log("ForgotPassApi params:", number, password);
  try {
    const response = await fetch(
      `${API_BASE_URL}/users/phoneNumber/${number}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          password,
        }),
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("GetReferralCode error", e);
  }
};

export const PutReferralApi = async ({ referralCode }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  console.log("PutReferralApi Params:", userId, referralCode, token);
  try {
    const response = await fetch(`${API_BASE_URL}/referrals/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        referralCode,
      }),
    });

    if (response.ok) {
      const data = await response.json();

      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("PutReferralApi error", e);
  }
};

export const UserValidateApi = async (data) => {
  console.log("UserValidateApi params:", data);
  try {
    const response = await fetch(`${API_BASE_URL}/users/validate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    // console.log('UserValidateApi response :',response)
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("UserValidateApi error", e);
  }
};

export const GetUserByIdApi = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("UserTalktimeApi Failed", e);
  }
};

export const DeleteAccountApi = async ({ phoneNumber, password }) => {
  console.log("DeleteAccountApi params:", phoneNumber, password);
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const token = userData.token;
  try {
    const response = await fetch(
      `${API_BASE_URL}/users/verifyUserForAccountDeletion`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          phoneNumber,
          password,
        }),
      }
    );
    if (!response.ok) {
      console.log("the response of the api is not okay ");
      throw new Error("Something went wrong!");
    }
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("DeleteAccountApi error", e);
  }
};

export const ConfirmDeleteAccount = async ({ data }) => {
  console.log("the value from the api is ", data);
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const token = userData.token;
  try {
    const response = await fetch(`${API_BASE_URL}/users/delete/${data}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`,
      },
      // body: JSON.stringify({
      //   phoneNumber,
      //   password
      // }),
    });
    if (!response.ok) {
      console.log("Some thing went wrong while fetching the api ");
    }
    if (response.ok) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    console.log("DeleteAccountApi error");
    return false;
  }
};

export const RegisterPsychologistApi = async data => {
  console.log('RegisterPsychologist params', data);

  try {
    const response = await fetch(`${API_BASE_URL}/psychologists/register/v2`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });


    if (response.ok) {
      const data = await response.json();

      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.log('Failed to register:', error);
  }
};

export const StartAudioPsychologistApi = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(
      `${API_BASE_URL}/agora/startCallWithPsychologist/${userId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("StartAudioPsychologistApi Failed", e);
  }
};

export const EndPsychologistApi = async ({
  timer,
  channelId,
  isPsychologist,
}) => {
  console.log(
    "EndPsychologistApi parmas Timer:",
    timer,
    "channelId",
    channelId,
    "isPsychologist",
    isPsychologist
  );
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const id = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(
      `${API_BASE_URL}/agora/endCallWithPsychologist`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          timer,
          channelId,
          isPsychologist,
          id,
        }),
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("StartAudioPsychologistApi Failed", e);
  }
};

export const NotifyVideoPsychologistApi = async (channelId) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  const senderName = userData.name;
  // console.log('UserId:',userId,'Token:',token);
  try {
    const response = await fetch(
      `${API_BASE_URL}/agora/notifyPsychologistsForVideo`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          senderName,
          channelId,
        }),
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("AgoraStartVideoApi Failed", e);
  }
};

export const NotifyAudioPsychologistApi = async (channelId) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  const senderName = userData.name;
  // console.log('UserId:',userId,'Token:',token);
  try {
    const response = await fetch(`${API_BASE_URL}/agora/notifyPsychologists`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        senderName,
        channelId,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("AgoraStartVideoApi Failed", e);
  }
};

export const StartVideoPsychologistApi = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    return null;
  }
  const userId = userData.userId;
  const token = userData.token;
  try {
    const response = await fetch(
      `${API_BASE_URL}/agora/startVideoCallWithPsychologist/${userId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("StartVideoPsychologistApi Failed", e);
  }
};

export const OtpInitiateForgotPassApi = async (email) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/security/forgotPassword?emailId=${email}&userType=user`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("OtpInitiateForgotPassApi error", e);
  }
};

export const VerifyOtpAndChangePassApi = async ({
  phoneNumber,
  newPassword,
  reEnterPassword,
  otp,
}) => {
  const userType = "user";
  try {
    const response = await fetch(
      `${API_BASE_URL}/security/verifyAndChangePassword`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phoneNumber,
          newPassword,
          reEnterPassword,
          userType,
          otp,
        }),
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("ChangePassApi error", e);
  }
};

export const ContactUsApi = async (data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/contactUs/createEnquiry`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.log("ContactUsApi failed with status:", response.status);
      return null;
    }
  } catch (e) {
    console.log("ContactUsApi error:", e);
    return null;
  }
};

export const PlansEmailVerifyApi = async (emailId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/plans/validateEmail/userPlanSubscription?emailId=${emailId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      console.warn(
        `PlansEmailVerifyApi failed: ${response.status} ${response.statusText}`
      );
      return null;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("PlansEmailVerifyApi error:", error);
    return null;
  }
};

export const EmployeeCareEmailVerifyApi = async (emailId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/plans/validateEmail/enterpriseAdminPlanSubscription?emailId=${emailId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      console.warn(
        `EmployeeCareEmailVerifyApi failed: ${response.status} ${response.statusText}`
      );
      return null;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("EmployeeCareEmailVerifyApi error:", error);
    return null;
  }
};

export const ClarityPlanListApi = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/plans/getAllUserPlans`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("ClarityPlanListApi error", e);
  }
};

export const PlansOrderCreateApi = async ({ amount, orderType, userId }) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/order/user-plan-subscription/create-order`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount,
          userId,
          orderType,
        }),
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("PlansOrderCreateApi Failed", e);
  }
};

export const EmployeeCareOrderCreateApi = async ({ amount, orderType, adminId }) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/order/enterpriseAdmin/createOrder`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount,
          adminId,
          orderType,
        }),
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("PlansOrderCreateApi Failed", e);
  }
};

export const PlansVerifyPaymentApi = async ({
  paymentId,
  signature,
  orderId,
}) => {
  console.log(
    "PlansVerifyPaymentApi is working with paymentId:",
    paymentId,
    "signature",
    signature,
    "orderId",
    orderId
  );
  try {
    const response = await fetch(
      `${API_BASE_URL}/order/user-plan-subscription/verifyPayment`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          paymentId,
          orderId,
          signature,
        }),
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("PlansVerifyPaymentApi Failed", e);
  }
};

export const EmployeeCareVerifyPaymentApi = async (orderId) => {

  try {
    const response = await fetch(
      `${API_BASE_URL}/order/enterpriseAdmin/verify`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          orderId,
        }),
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("PlansVerifyPaymentApi Failed", e);
  }
};

export const WccAssignPlanApi = async ({ planId, amount, userId }) => {
  try {
    const response = await fetch(`${API_BASE_URL}/plans/assignPlanToUser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        planId,
        amount,
        userId,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("WccAssignPlanApi Failed", e);
  }
};

export const GetGoodCallPlanListApi = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/plans/getAllGoodCallPlan`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("GetGoodCallPlanListApi error", e);
  }
};

export const GoodCallPlanAssignApi = async ({ planId, amount, userId }) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/plans/assignGoodCallSubscriptionToUser`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          planId,
          amount,
          userId,
        }),
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("GoodCallPlanAssignApi Failed", e);
  }
};

export const GetEmployeeFirstPlanListApi = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/plans/getAllPlans`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("GetGoodCallPlanListApi error", e);
  }
};

export const EmployeeCarePlanAssignApi = async ({
  planId,
  amount,
  noOfUser,
  adminId,
}) => {
  try {
    const response = await fetch(`${API_BASE_URL}/plans/assignPlanToAdmin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        planId,
        amount,
        adminId,
        noOfUser,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (e) {
    console.log("GoodCallPlanAssignApi Failed", e);
  }
};

// Audio 

export const GetAllSleepCategoriesApi = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    console.log("No user data found in localStorage.");
    return null;
  }
  const token = userData.token;

  try {
    const response = await fetch(
      `${API_BASE_URL}/sleepCategory/getAllSleepCategory`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.ok) {
      return await response.json();
    } else {
      const error = await response.json();
      console.log("GetAllPodcastCategoriesApi Error:", error);
      return null;
    }
  } catch (error) {
    console.log("GetAllPodcastCategoriesApi error:", error);
    return null;
  }
};


export const GetSleepByCategoryId = async (categoryId) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    console.log("No user data found in localStorage.");
    return null;
  }
  const token = userData.token;

  try {
    const response = await fetch(
      `${API_BASE_URL}/sleepPodcast/getByCategoryId?categoryId=${encodeURIComponent(categoryId)}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.ok) {
      return await response.json();
    } else {
      const error = await response.json();
      console.log("GetPodcastByCategoryId Error:", error);
      return null;
    }
  } catch (error) {
    console.log("GetPodcastByCategoryId error:", error);
    return null;
  }
};

export const GetAllPodcastCategoriesApi = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    console.log("No user data found in localStorage.");
    return null;
  }
  const token = userData.token;

  try {
    const response = await fetch(
      `${API_BASE_URL}/category/getAllPodcastCategory`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.ok) {
      return await response.json();
    } else {
      const error = await response.json();
      console.log("GetAllPodcastCategoriesApi Error:", error);
      return null;
    }
  } catch (error) {
    console.log("GetAllPodcastCategoriesApi error:", error);
    return null;
  }
};

export const GetPodcastByCategoryId = async (categoryId) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  if (!userData) {
    console.log("No user data found in localStorage.");
    return null;
  }
  const token = userData.token;

  try {
    const response = await fetch(
      `${API_BASE_URL}/podcasts/getByCategoryId?categoryId=${encodeURIComponent(categoryId)}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.ok) {
      return await response.json();
    } else {
      const error = await response.json();
      console.log("GetPodcastByCategoryId Error:", error);
      return null;
    }
  } catch (error) {
    console.log("GetPodcastByCategoryId error:", error);
    return null;
  }
};


export const EmployeeFirstFormApi = async (formData) => {


  try {
    const response = await fetch(
      `${API_BASE_URL}/contactUs/employeeCare`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      const errorData = await response.json();
      console.error("EmployeeFirstFormApi error:", errorData);
      return null;
    }
  } catch (e) {
    console.error("EmployeeFirstFormApi Failed", e);
    return null;
  }
};
